import React from "react";
import { Modal, ModalContent, ModalTitle } from "storefront/components/ModalV2";
import Authentication, { Props as AuthProps } from "./index";
import styles from "./Modal.module.scss";

export type AuthenticationModalProps = Omit<
  AuthProps,
  "onPhoneVerificationMount"
> & {
  isOpen: boolean;
  onRequestClose: () => void;
};

// Google's reCAPTCHA challenge is an iframe injected directly onto document.body.
// When it's visible, clicking its overlay fires Radix's "interact outside" handler,
// which would dismiss the auth modal and prevent the user from completing the challenge.
// The challenge iframe uses "bframe" in its src, distinguishing it from the badge iframe.
const isRecaptchaChallengeVisible = (): boolean => {
  const iframe = document.querySelector(
    'iframe[src*="/recaptcha/api2/bframe"]',
  );
  if (!iframe) return false;
  const container = iframe.closest("body > div");
  if (!container) return false;
  const style = window.getComputedStyle(container);
  return style.visibility !== "hidden" && style.opacity !== "0";
};

const AuthenticationModal = ({
  isOpen,
  onSuccess,
  onError,
  onRequestClose,
  currentUser,
  authType,
  verifications,
}: AuthenticationModalProps) => (
  <Modal open={isOpen} onRequestClose={onRequestClose}>
    <ModalContent
      className={styles.authenticationModal}
      aria-describedby={undefined}
      onInteractOutside={(e) => {
        if (isRecaptchaChallengeVisible()) {
          e.preventDefault();
        }
      }}
    >
      <ModalTitle hidden>Authentication</ModalTitle>
      <Authentication
        currentUser={currentUser}
        onSuccess={onSuccess}
        onError={onError}
        authType={authType}
        verifications={verifications}
      />
    </ModalContent>
  </Modal>
);

export default AuthenticationModal;
